import { date, mixed, object } from "yup";

export const QBOAddDetailsValidation = object({
  date_till_import: date().required("Start date is required"),
  prev_fy_end_date: date().required(
    "Previous financial year end date is required"
  ),
  coa_file: mixed().required("Chart of Accounts is required"),
  balance_sheet_file: mixed().required("Balance Sheet is required"),
  vendor_file: mixed().required("Vendors List is required"),
  customer_file: mixed().required("Customers List is required"),
  je_file: mixed().required("Journal Entries is required"),
  invoice_file: mixed().required(
    "Invoices and Received Payments report is required"
  ),
  bill_file: mixed().required("Bills and Applied Payments report is required"),
});
